<script setup>
import { supabase } from '@/supabase';
import { onMounted, onUnmounted, defineEmits } from 'vue';
import { ref } from 'vue'
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import Dialog from 'primevue/dialog'
import InputNumber from 'primevue/inputnumber'
import Dropdown from 'primevue/dropdown'
// variável do forms api
let isInit = false;
let gisInited = false;
let gapiInited = false;
let tokenClient;


// Função para adicionar o script dinamicamente
const loadScript = (id, src, onLoad) => {
    if (document.getElementById(id)) {
        return; // Script já adicionado
    }
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = onLoad;
    document.head.appendChild(script);
};

// Função para remover o script (opcional)
const removeScript = (id) => {
    const script = document.getElementById(id);
    if (script) {
        document.head.removeChild(script);
    }
};

// Funções específicas para carregar e remover os scripts do Google
const loadGoogleScripts = () => {
    loadScript('google-api', 'https://apis.google.com/js/api.js', () => {
        console.log('Google API script carregado');
        gapiLoad()
    });
    loadScript('google-gis', 'https://accounts.google.com/gsi/client', () => {
        console.log('Google Identity Services script carregado');
        gisInit()
    });
};

const unloadGoogleScripts = () => {
    removeScript('google-api');
    removeScript('google-gis');
};

onMounted(() => {
    loadGoogleScripts();
});

onUnmounted(() => {
    unloadGoogleScripts();
});


// funções padrão para incializar o formulário e função de autenticação
function formsAutenticacao() {
    return new Promise((resolve, reject) => {
        tokenClient.callback = (resp) => {
            if (resp.error !== undefined) {
                reject(resp);
            }
            resolve(true);
        }

        if (gapi.client.getToken() === null) {

            tokenClient.requestAccessToken({ prompt: 'consent' });
        } else {
            tokenClient.requestAccessToken({ prompt: '' });
            resolve(true);
        }
    });
}

function checkBeforeStart() {
    if (gapiInited && gisInited) {
        // Start only when both gapi and gis are initialized.
        isInit = true;
    }
}

function gisInit() {

    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: '758705817118-7miqlg8frcimb74s2kn0utciecf8sls2.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/drive.file',
        callback: '',  // defined at request time
    });
    gisInited = true;
    checkBeforeStart();
}

function gapiInit() {
    gapi.client.init({
        // NOTE: OAuth2 'scope' and 'client_id' parameters have moved to initTokenClient().
    })
        .then(function () {  // Load the Calendar API discovery document.
            gapi.client.load('https://forms.googleapis.com/$discovery/rest?version=v1');
            gapiInited = true;
            checkBeforeStart();
        });
}

function gapiLoad() {
    gapi.load('client', gapiInit);
}



const loading = ref(false);
const pontuacaoMaximaForms = ref()
const formularioImportarNotasSelecionado = ref()
const props = defineProps({
    visibleImportarNotas: Boolean,
    avaliacoesComFormularios: Array,
    estudantes: Array,

})

const emit = defineEmits(['update:importarNotasModalVisible'])


const fecharImportarNotasModal = () => {
  emit('update:importarNotasModalVisible', false)
}


async function importarNotasDoFormulario() {
    const estudantes = []
    props.estudantes.forEach(estudante => {
        estudantes.push({nome: estudante.nome, id: estudante.id})
    })

    console.log(estudantes)
    
    const avaliacaoSelecionada = props.avaliacoesComFormularios.find(avaliacao => avaliacao.id === formularioImportarNotasSelecionado.value);
    if (avaliacaoSelecionada) {
        loading.value = true
        let totalPontosForms = pontuacaoMaximaForms.value;
        let idAtividade = avaliacaoSelecionada.id;
        let idForm = avaliacaoSelecionada.forms_id;
        let idQuestaoNome = avaliacaoSelecionada.idQuestaoComNomes;


        try {
            let authResult = await formsAutenticacao();
            if (authResult) {
                // a autenticação foi bem-sucedida, continue a execução
            }
        } catch (error) {
            // a autenticação falhou, aborte a execução ou manipule o erro
            loading.value = false
            console.log('A autenticação falhou', error);
            return;
        }

         return gapi.client.forms.forms.responses.list({
            "formId": idForm
        })
            .then(function (response) {
                let data = JSON.parse(response['body']);

                if (Object.keys(data).length > 0) {

                    let resultados = data.responses.map(resposta => {
                        let nomeDoEstudante = resposta.answers[idQuestaoNome].textAnswers.answers[0].value;
                        let pontuacaoDoEstudante = resposta.totalScore;
                        let percentualDeAcertos = (pontuacaoDoEstudante / totalPontosForms) * 100;

                        return {
                            nome: nomeDoEstudante,
                            percentualDeAcertos: percentualDeAcertos
                        };
                    });

                    resultados.forEach(async (estudante) => {

                        const id = estudantes.find(aluno => aluno.nome === estudante.nome).id
                        
                        const { data, error } = await supabase
                            .from('planos_notas')
                            .update({
                                nota: estudante.percentualDeAcertos
                            })
                            .eq('avaliacao', idAtividade)
                            .eq('estudante', id)
                            .select()
                            console.log(data)
                    });

                    loading.value = false
                    pontuacaoMaximaForms.value =  0

                    alert('As notas foram importadas com sucesso! Recarregue a página para visualizá-las.');


                } else {
                    loading.value = false
                    alert('O formulário ainda não tem nenhuma resposta para ser importada!');
                }
            },
                function (err) { console.error("Execute error", err); });

    }
}


</script>

<template>
    
    <Dialog v-model:visible="props.visibleImportarNotas" header="Importar Notas de Formulários" modal position="center" :closable=false
        :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '100vw' }" class="m-0 md:m-5">
        <ProgressSpinner v-if="loading" class="spinner z-5" style="width: 50px; height: 50px" strokeWidth="8" fill="var(--surface-ground)"
                        animationDuration=".5s" aria-label="Custom ProgressSpinner"/>
        <div v-if="props.avaliacoesComFormularios.length > 0">
            <Dropdown v-model="formularioImportarNotasSelecionado" :options="props.avaliacoesComFormularios"
                optionLabel="titulo_avaliacao" optionValue="id" placeholder="Selecione um formulário"
                class="w-full mt-1 mb-3" />
            <InputNumber v-model="pontuacaoMaximaForms" :disabled="!formularioImportarNotasSelecionado" type="number"
                placeholder="Defina a pontuação máxima" class="mb-3 w-full" />
            <div class="flex gap-2 justify-content-end">
                <Button label="Importar" :disabled="pontuacaoMaximaForms < 1" class="mt-2 "
                @click="importarNotasDoFormulario()" />
                <Button label="Fechar" class="mt-2 "
                @click="fecharImportarNotasModal" severity="secondary"  />
            </div>

            
        </div>
        <div v-else>
            Você ainda não criou nenhum formulário
        </div>

    </Dialog>
</template>
<style scoped>
.spinner {
    z-index: 9999;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>